import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { RequiredActionsComponent } from './required-actions/required-actions.component';

const routes: Routes = [
  { path: 'change-password', component: ChangePasswordComponent},
  { path: 'forgot-password', component: ForgotpasswordComponent},
  { path: 'required-actions', component: RequiredActionsComponent},
]

@NgModule({
  declarations: [ ForgotpasswordComponent, ChangePasswordComponent,RequiredActionsComponent ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    SharedModule,
    MaterialModule
  ],
  exports: [
    ForgotpasswordComponent,
    ChangePasswordComponent,RequiredActionsComponent
  ]
})
export class AuthenticationModule { }
